import { render, staticRenderFns } from "./xfsMachine.vue?vue&type=template&id=10ea64ad&scoped=true"
import script from "./xfsMachine.vue?vue&type=script&lang=js"
export * from "./xfsMachine.vue?vue&type=script&lang=js"
import style0 from "./xfsMachine.vue?vue&type=style&index=0&id=10ea64ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea64ad",
  null
  
)

export default component.exports